import ReactOnRails from 'react-on-rails';

// eslint-disable-next-line @typescript-eslint/no-unsafe-return
export const getStore = (): any => ReactOnRails.getStore('orderMadeStore', false);
